var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isModalVisible)?_c(_vm.modalComponent,_vm._b({tag:"component",on:{"onModalClosed":_vm.onModalClosed,"close":_vm.onModalClosed,"submit":_vm.onSignAndShowPinClicked}},'component',_vm.modalComponentProps,false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }